import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import { sessionKeys } from './queries'

/**
 * Renders nothing. Owns the single onAuthStateChange subscription for the whole
 * app and writes each new session straight into the query cache, so every
 * session-derived query reacts without any component remounting.
 *
 * Must be inside QueryClientProvider (see main.tsx).
 */
export function AuthStateBridge() {
  const queryClient = useQueryClient()

  useEffect(() => {
    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      queryClient.setQueryData(sessionKeys.supabaseSession, session)
      // A fresh sign-in mints a token with the tenant claims; anything cached
      // from before it (including a null profile) is stale by definition.
      if (event === 'SIGNED_IN' || event === 'SIGNED_OUT') {
        void queryClient.invalidateQueries({ queryKey: ['profile'] })
      }
    })
    return () => {
      sub.subscription.unsubscribe()
    }
  }, [queryClient])

  return null
}
